// delay-tiles.js — <select is-delay-option> / is-delay-option-results → tuiles (J+N + libellé), scope .imposition-v3 uniquement.

(function () {
  function calcT(key, fallback, vars) {
    var dict = window.__calculatorI18n || {};
    var text = dict[key] != null ? String(dict[key]) : String(fallback == null ? key : fallback);
    if (vars) Object.keys(vars).forEach(function (name) { text = text.split('{' + name + '}').join(String(vars[name])); });
    return text;
  }

  function impositionSection() {
    return document.querySelector("section.imposition-v3");
  }

  function parseDelayDays(raw) {
    var text = String(raw || "").toLowerCase();
    var jMatch = text.match(/j\s*\+?\s*(\d+)/i);
    if (jMatch && jMatch[1]) return Math.max(0, parseInt(jMatch[1], 10) || 0);
    var dayMatch = text.match(/(\d+)\s*(?:jour|jours)/i);
    if (dayMatch && dayMatch[1]) return Math.max(0, parseInt(dayMatch[1], 10) || 0);
    var fallback = text.match(/\b(\d{1,2})\b/);
    if (fallback && fallback[1]) return Math.max(0, parseInt(fallback[1], 10) || 0);
    return null;
  }

  function tierLabel(day) {
    if (day === 5) return calcT("delay_economy", "Économique");
    if (day === 2) return calcT("delay_standard", "Standard");
    if (day === 1) return calcT("delay_express", "Express");
    if (day === 0) return calcT("delay_urgent", "Urgence");
    return calcT("delay_unknown", "Délai");
  }

  function jLine(day) {
    return day === 0 ? "J + 0" : "J + " + day;
  }

  function hideSelectVisually(select) {
    var wrap = select.closest(".select--wrap") || select.parentElement;
    if (!wrap) return;
    wrap.style.position = "absolute";
    wrap.style.width = "1px";
    wrap.style.height = "1px";
    wrap.style.padding = "0";
    wrap.style.margin = "-1px";
    wrap.style.overflow = "hidden";
    wrap.style.clipPath = "inset(50%)";
    wrap.style.border = "0";
    wrap.style.whiteSpace = "nowrap";
    wrap.style.pointerEvents = "none";
    select.style.opacity = "0";
    select.style.width = "1px";
    select.style.height = "1px";
  }

  function removeTilesAfterWrap(select) {
    var wrap = select.closest(".select--wrap");
    if (!wrap) return;
    var el = wrap.nextElementSibling;
    while (el && el.classList && el.classList.contains("delay-tiles")) {
      var next = el.nextElementSibling;
      el.remove();
      el = next;
    }
  }

  function makeDelayTiles(select) {
    var section = impositionSection();
    if (!section || !section.contains(select)) return;

    removeTilesAfterWrap(select);

    var opts = Array.prototype.slice.call(select.options || []).filter(function (o) {
      return (o.value || "").trim() !== "";
    });
    if (!opts.length) return;

    var decorated = opts.map(function (opt) {
      var d = parseDelayDays(opt.value);
      if (d === null) d = parseDelayDays(opt.textContent);
      if (d === null) d = -1;
      return { opt: opt, days: d };
    });

    decorated.sort(function (a, b) {
      if (a.days < 0 && b.days < 0) return 0;
      if (a.days < 0) return 1;
      if (b.days < 0) return -1;
      return b.days - a.days;
    });

    var wrapAnchor = select.closest(".select--wrap");
    if (!wrapAnchor) return;

    var host = select.closest(".input--box") || select.closest(".calc-results-delay");
    if (host) host.style.position = "relative";

    var row = document.createElement("div");
    row.className = "delay-tiles";
    row.setAttribute("role", "radiogroup");
    row.setAttribute("aria-label", calcT("production_delay", "Délai de production"));

    var tiles = [];

    decorated.forEach(function (item) {
      var opt = item.opt;
      var day = item.days;
      var tile = document.createElement("button");
      tile.type = "button";
      tile.className = "delay-tile";
      tile.setAttribute("role", "radio");
      tile.setAttribute("aria-checked", opt.selected ? "true" : "false");
      tile.dataset.value = opt.value;

      var jEl = document.createElement("div");
      jEl.className = "delay-tile__j";
      jEl.textContent = day >= 0 ? jLine(day) : (opt.textContent || "").trim();

      var tierEl = document.createElement("div");
      tierEl.className = "delay-tile__tier";
      tierEl.textContent = day >= 0 ? tierLabel(day) : "";

      tile.appendChild(jEl);
      if (tierEl.textContent) tile.appendChild(tierEl);

      tile.addEventListener("click", function () {
        select.value = opt.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        tiles.forEach(function (t) {
          t.setAttribute("aria-checked", "false");
        });
        tile.setAttribute("aria-checked", "true");
      });

      row.appendChild(tile);
      tiles.push(tile);
    });

    wrapAnchor.insertAdjacentElement("afterend", row);

    function syncAria() {
      var v = select.value;
      tiles.forEach(function (t) {
        t.setAttribute("aria-checked", t.dataset.value === v ? "true" : "false");
      });
    }

    if (select._delayTilesAbort) select._delayTilesAbort.abort();
    var ac = new AbortController();
    select._delayTilesAbort = ac;
    select.addEventListener("change", syncAria, { signal: ac.signal });

    hideSelectVisually(select);
    syncAria();
  }

  var debouncers = new WeakMap();

  function debouncedRebuild(select) {
    var id = debouncers.get(select);
    if (id) clearTimeout(id);
    id = setTimeout(function () {
      debouncers.delete(select);
      makeDelayTiles(select);
    }, 60);
    debouncers.set(select, id);
  }

  function bindSelect(select) {
    if (!select || select.dataset.delayTilesBound === "1") return;
    select.dataset.delayTilesBound = "1";
    makeDelayTiles(select);
    var obs = new MutationObserver(function () {
      debouncedRebuild(select);
    });
    obs.observe(select, { childList: true, subtree: true });
  }

  function init() {
    var root = impositionSection();
    if (!root) return;
    var main = root.querySelector("[is-delay-option]");
    var results = root.querySelector("[is-delay-option-results]");
    bindSelect(main);
    bindSelect(results);
  }

  function scheduleInit() {
    init();
    requestAnimationFrame(function () {
      requestAnimationFrame(init);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleInit, { once: true });
  } else {
    scheduleInit();
  }
})();